import tarotFortuneChange from './actions/tarotFortuneChange';
import tarotFortuneCreate from './actions/tarotFortuneCreate';
import tarotFortuneDetail from './actions/tarotFortuneDetail';
import tarotFortunesList from './actions/tarotFortunesList';
import getTarotFortunes from './getters/getTarotFortunes';
import tarotFortunesUpload from './mutations/tarotFortunesUpload';

const actions = {
    tarotFortuneChange,
    tarotFortuneCreate,
    tarotFortuneDetail,
    tarotFortunesList
};

const mutations = {
    tarotFortunesUpload
};

const getters = {
    getTarotFortunes
};

export default { actions, mutations, getters };
